import { ButtonPrimary, ButtonWithIcon } from '@ui/button';
import { IconArrowDown, IconArrowUp } from '@ui/icons';
import { Link } from '@lib/routing-engine';
import { useStore } from '@lib/state-engine';
import { OutsideClick } from '@lib/outside-click';
import { $dropdownOpened, toggleOpenDropdown } from './model';
import styles from './styles.module.css';
import { $isSubscribed, $userPermissions, switchDisplayBuySubscription } from '@/modules/auth/store/auth.store';

export const StorageCreateWarehouse = () => {
  const opened = useStore($dropdownOpened);
  const isSubscribed = useStore($isSubscribed);
  const userPermissions = useStore($userPermissions);

  return (
    <div className={styles.container}>
      <ButtonPrimary
        className={styles.button}
        label="Добавить склад"
        iconRight={opened ? IconArrowUp : IconArrowDown}
        onClick={() => toggleOpenDropdown(!opened)}
        data-opened={opened}
      />
      {opened && (
        <OutsideClick onClickOutside={() => toggleOpenDropdown(false)}>
          <ul>
            <li>
              <Link

                to="/storage/create-warehouse"
                className={styles.link}
                onClick={(e) => {
                  if (isSubscribed === false || !userPermissions.storage) {
                    e.preventDefault();
                    return switchDisplayBuySubscription(true);
                  }
                  toggleOpenDropdown(false)
                }}
                aria-disabled={isSubscribed === false}
              >
                <ButtonWithIcon icon="WarehouseSleeveList" />
                &nbsp;рукавный
              </Link>
            </li>
            <li>
              <Link
                to="/storage/create-warehouse/fixed"
                className={styles.link}
                onClick={() => toggleOpenDropdown(false)}
              >
                <ButtonWithIcon icon="WarehouseStationaryList" />
                &nbsp;стационарный
              </Link>
            </li>
          </ul>
        </OutsideClick>
      )}
    </div>
  );
};
